import { ActivityResultDisplayModel, CzShipmentDisplayModel } from '../../service/kvaw0500.vo';

/**
 * クライアント内部で利用するデータを保持するインターフェース
 */
export interface Kvap0800ViewModel {
  /** 相手先コード */
  storeCode?: string;
  /** 相手先略称 */
  storeName?: string;
  /** 業務年月日 */
  businessDate?: string;
  /** 入店日時 */
  enterDateTime?: string;
  /** 退店日時 */
  exitDateTime?: string;
  /** 活動項目 */
  activityItemList?: ActivityItemListViewModel[];
  /** 活動ランク */
  activityRankList?: ActivityRankListViewModel[];
  /** 報告用写真情報 */
  photoInfoList?: PhotoInfoListViewModel[];
  /** 写真タグセレクトリスト */
  photoTagSelectList?: PhotoTagSelectListViewModel[];
  /** 店頭化報告内容 */
  storeFrontReportContent?: string;
  /** 商談報告内容 */
  businessDiscussionReportContent?: string;
  /** 競合情報報告内容 */
  rivalryInfoReportContent?: string;
  /** その他メモ報告内容 */
  etcMemoReportContent?: string;
  /** 店頭化プレースホルダー */
  storeFrontReportPlaceHolder?: string;
  /** 商談プレースホルダー */
  businessDiscussionReportPlaceHolder?: string;
  /** 競合情報プレースホルダー */
  rivalryInfoReportPlaceHolder?: string;
  /** その他メモプレースホルダー */
  etcMemoReportPlaceHolder?: string;
}

export interface ActivityItemListViewModel extends ActivityResultDisplayModel {
  /** アコーディオンの開閉を判定するための値 */
  checked?: boolean;
  /** 活動項目、活動ランクの項目名として表示する文字列 */
  dispText?: string;
  /** 活動実績値 */
  activityResultVal?: string;
}

export interface ActivityRankListViewModel extends CzShipmentDisplayModel {
  /** アコーディオンの開閉を判定するための値 */
  checked?: boolean;
  /** 活動項目、活動ランクの項目名として表示する文字列 */
  dispText?: string;
  /** 活動ランク実績値 */
  activityRankResultVal?: string;
}

export interface PhotoInfoListViewModel {
  /** 写真コード */
  photoCode?: string;
  /** 画像コード */
  imageCode?: string;
  /** 写真ファイルパス */
  photoFilePath?: string;
  /** 画像データ */
  imageData?: string;
  /** 写真タグコード */
  photoTagCode?: string;
  /** 写真タグ名称 */
  photoTagName?: string;
  /** 写真操作フラグ */
  photoOperationFlg?: string;
}

export interface PhotoTagSelectListViewModel {
  /** 写真タグコード */
  photoTagCode?: string;
  /** 写真タグ表示名 */
  photoTagDisplayName?: string;
}

/** 入力区分（トグル、プルダウン、数値入力の切替用） */
export enum InputType {
  toggle = '1',
  select = '2',
  input = '3',
}

/** API呼び出しパターン（担当店（新規）、一時保存、送信済日報、担当店外（新規） */
export enum ApiCallType {
  inCharge = '1',
  saved = '2',
  sent = '3',
  outside = '4',
}

/** 写真操作フラグ */
export enum PhotoOperationFlgType {
  noChange = '0',
  add = '1',
  update = '2',
  delete = '3',
}



// WEBPACK FOOTER //
// ./src/app/component/kvap0800/kvap0800.view-model.ts